import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

const portalId = "1c6b26a9a14e4132895194e80d6b30f8";

export const muniLayer = new FeatureLayer({
  portalItem: {
    id: portalId
  },
  renderer: {
    type: 'simple',
    symbol: {
      type: "simple-line",
      color: 'black',
      width: '1px',
    }
  }
});
